import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';

import {DATE_MAX} from '../../../app.constants';
import {CliEmpAttributes} from '../../../models/models.interfaces';
import {Data} from '../../api';
import {Contract} from '../../employees/employees.model';
import {EmployeesService} from '../../employees/employees.service';
import {DateLocalizationPipe} from '../../pipes/date-localization.pipe';
import {WizardService} from '../../ui/wizard.service';
import {ListValue, OptionsForCopy} from '../hire.interface';

@Component({
  selector: 'gp-hire-options-copy',
  templateUrl: './hire-options-copy.component.html'
})
export class HireOptionsCopyComponent implements OnInit, OnChanges {

  @Input()
  public selectedEmployee: Data<CliEmpAttributes>;

  @Input()
  public contracts: Contract[];

  @Input()
  public cliRegId: number;

  @Input()
  public optionToCopyForm: UntypedFormGroup;

  public optionsForCopy: OptionsForCopy;

  constructor(private formBuilder: UntypedFormBuilder,
              private translate: TranslateService,
              private employeesService: EmployeesService,
              private wizardService: WizardService,
              private dateLocalizationPipe: DateLocalizationPipe) {
    this.customPlaceholderGenerator = this.customPlaceholderGenerator.bind(this);
    this.resetOptions();
  }

  ngOnInit() {
    this.optionToCopyForm.addControl('selectedCopyInfoOption', this.formBuilder.control('', []));
    this.optionToCopyForm.addControl('selectedContract', this.formBuilder.control('', []));
    this.optionToCopyForm.setValidators((group: UntypedFormGroup) => {
      return group.get('selectedCopyInfoOption').value
        && (this.contracts && !group.get('selectedContract').value ? {no_contract: true} : null);
    });
  }

  ngOnChanges() {
    if (!this.cliRegId) {
      this.resetOptions();
      return;
    }
    this.employeesService.getOptionsForCopy(this.cliRegId)
      .subscribe((options: ListValue[]) => {
        this.optionsForCopy.items = options;
        this.wizardService.updateCopyOptionsList(options);
      });
  }

  public customPlaceholderGenerator(contract: Contract): string {
    const text: string = this.translate.instant('EMPLOYEE_FORM.Contract_name', {
      name: contract.cliRegNickName
    });

    return contract.flag
      ? `<img class="flag-icon" src="${contract.flag.href}" /> ${text} ${this.getContractDate(contract)}`
      : `${text} ${this.getContractDate(contract)}`;
  }

  public getContractDate(contract: Contract): string {
    return `(${
      this.dateLocalizationPipe.transform(contract.begindate)
    } - ${
      contract.enddate === DATE_MAX || !contract.enddate
        ? '...'
        : this.dateLocalizationPipe.transform(contract.enddate)
    })`;
  }

  public isInactiveContract(enddate: Date): boolean {
    return moment(enddate).isAfter(moment());
  }

  public resetOptions() {
    this.optionsForCopy = {
      items: [],
      selectedCopyInfoOption: null,
      selectedContract: null
    };
  }
}
